export enum FileType {
  Unknown = 0,
  CSV = 1,
  PDF = 2,
  JPG = 3,
  PNG = 4,
  XLSX = 5,
  JSON = 6,
  DOCX = 7
}
export const FileTypeMapping: Record<FileType, string> = {
  [FileType.Unknown]: 'Unknown',
  [FileType.CSV]: 'CSV',
  [FileType.PDF]: 'PDF',
  [FileType.JPG]: 'JPG',
  [FileType.PNG]: 'PNG',
  [FileType.XLSX]: 'XLSX',
  [FileType.JSON]: 'JSON',
  [FileType.DOCX]: 'DOCX'
};
